module.exports = __webpack_public_path__ + "by.svg?a75b5914f565f6064265c8571fa00e9b";